'use client';

import Link from '@/components/ui/Link';
import { accountTabs } from '@/constants';
import { usePathname } from '@/i18n/navigation';
import { cn } from '@/utils/tailwind-merge';
import { useTranslations } from 'next-intl';

export default function AccountTabs() {
    const t = useTranslations('Account');
    const pathname = usePathname();

    return (
        <div className="flex items-center 2xl:gap-[90px] gap-10 max-lg:gap-0 max-xl:overflow-auto pb-3 font-light border-b border-white/50 max-xl:w-[calc(100%+40px)]">
            {accountTabs(t).map(({ label, link, path }, index) => {
                const isActive = pathname === path;

                return (
                    <Link
                        className={cn(
                            'text-white lg:text-[26px] text-md max-lg:pr-7 uppercase text-nowrap',
                            isActive && 'text-primary',
                        )}
                        href={link}
                        key={index}
                    >
                        <>{label}</>
                    </Link>
                );
            })}
        </div>
    );
}
